<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="flex flex-row gap-2 mt-8">
    <button
      :class="iconClass"
      @click="$emit('previous')"
    >
      <FaIcon
        name="angle-left"
        iconStyle="light"
      />
    </button>
    <button
      v-if="!isPlaying"
      @click="handlePlay"
      :class="iconClass"
    >
      <FaIcon
        name="play"
        iconStyle="light"
      />
    </button>
    <button
      v-else
      @click="handlePause"
      :class="iconClass"
    >
      <FaIcon
        name="pause"
        iconStyle="light"
      />
    </button>
    <button
      :class="iconClass"
      @click="$emit('next')"
    >
      <FaIcon
        name="angle-right"
        iconStyle="light"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
const isPlaying = defineModel<boolean>({ default: true });

const emit = defineEmits(['play', 'pause', 'previous', 'next']);

const handlePlay = () => {
  emit('play');
  isPlaying.value = !isPlaying.value;
};

const handlePause = () => {
  emit('pause');
  isPlaying.value = !isPlaying.value;
}

const iconClass = "text-red-600 border border-red-600/20 p-0.5 w-8 h-8 hover:border-red-600 focus:border-red-600";
</script>
